<div class="quick-bet__help" [@fade]="isFade() ? 'out' : 'in'" (bsClickOutsideOrScroll)="closeWithAnimation()" (@fade.done)="animationDone($event)">
    <div class="quick-bet__help-caption-row">
        <span class="quick-bet__help-title">{{ sitecore.quickBetHelp.Title }}</span>
        <span class="quick-bet__help-badge">{{ sitecore.quickBetHelp.NewBadge }}</span>
    </div>
    <div class="quick-bet__help-message">{{ sitecore.quickBetHelp.Message }}</div>
    <div class="quick-bet__help-close theme-ex" (click)="close()"></div>
</div>
